var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStanford(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.078 98.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0.84 14.582 0.84 49.735 12.79 61.688 41.354 61.686 41.354 73.893 26.669 73.893 26.669 65.932 0.866 65.932 0.866 85.15 12.866 97.245 52.227 97.245 64.177 85.304 64.177 49.745 52.001 37.978 25.785 37.978 25.786 24.888 40.293 24.887 40.293 33.909 64.176 33.909 64.177 14.596 50.804 0.915 14.596 0.915",
    fill: "#8C1515"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2.413 15.294v33.82l11.017 11.019s26.638 0 29.497-0.001c0 2.412 0 12.98-0.001 15.391-2.497 0-15.368 0-17.868 0.002 0.001-2.037 0.001-7.961 0.001-7.961l-22.62-0.001v16.952l11.051 11.178h38.067l11.009-11.017v-34.253l-11.263-10.814h-27.13c0.001-2.445 0.001-13.831 0-16.275h17.693v9.02h20.7v-17.052l-12.437-12.755h-34.911l-12.805 12.747z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.868 4.253 4.015 16.083 4.015 48.571 14.098 58.656 44.527 58.656 44.526 77.233 23.475 77.233 23.475 69.271 4.038 69.272 4.038 83.956 14.142 94.215 50.913 94.215 60.981 84.123 60.983 51.181 50.634 41.316 22.589 41.315 22.588 21.856 43.467 21.856 43.467 30.878 60.981 30.878 60.983 16.083 49.482 4.253",
    fill: "#8C1515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStanford);
export default __webpack_public_path__ + "static/media/stanford.5ef299f3aebc4f1705263c2aae84961f.svg";
export { ForwardRef as ReactComponent };